<script>
import BaseSubNav from "@/components/ui/BaseSubNav.vue";
import validationService from "@/services/validation";
import { startCase, toLower } from "lodash";
import pagination from "@/mixins/pagination";

export default {
  name: "ValidationHistory",
  mixins: [pagination],
  components: {
    BaseSubNav,
  },
  data() {
    return {
      validations: [],
      isLoading: false,
    };
  },

  async created() {
    await this.getValidations();
  },

  methods: {
    startCase,
    toLower,

    getStatusIcon(status) {
      switch (status) {
        case "valid":
          return {
            name: "check_circle_outline",
            color: "#67c23a",
          };
        case "invalid":
          return {
            name: "cancel_circle_outline",
            color: "#f56c6c",
          };
        case "pending":
          return {
            name: "schedule",
            color: "#e6a23c",
          };
        default:
          return {
            name: "help_outline",
            color: "#909399",
          };
      }
    },

    getStatusText(status) {
      switch (status) {
        case "valid":
          return "Válido";
        case "invalid":
          return "Inválido";
        case "pending":
          return "Pendiente";
        default:
          return "Desconocido";
      }
    },
    async getValidations() {
      this.isLoading = true;
      try {
        const query = {
          offset: this.pagination.offset,
          limit: this.pagination.limit,
        };

        const response = await validationService.get(query);
        this.validations = response.docs || response || [];
        this.pagination.total = response.total || 0;
      } catch (error) {
        console.error("Error al obtener las validaciones:", error);
      } finally {
        this.isLoading = false;
      }
    },

    onPageChange() {
      this.getValidations();
    },

    formatTime(dateStr) {
      if (!dateStr) return "";
      const d = new Date(dateStr);
      return isNaN(d)
        ? ""
        : d.toLocaleTimeString("es-AR", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
          });
    },

    getFailureReasonsText(failureReasons) {
      if (!failureReasons || !Array.isArray(failureReasons)) {
        return "Razón desconocida";
      }

      const reasonsMap = {
        invalid_token: "Token inválido",
        invalid_patient_status: "Estado del paciente inválido",
        invalid_medical_service: "Prestación inválida",
      };

      return failureReasons
        .map((reason) => reasonsMap[reason] || reason)
        .join(" / ");
    },
  },
};
</script>

<template lang="pug">
div
  BaseSubNav(
    navigationType="validation"
    :showNavigation="true"
  )
    template(#title)
      | Validaciones
    
  .box.box--with-subnav(v-if="validations.length > 0")
    .box__content--stretch
      table
        thead
          tr
            th Paciente
            th Cod. Prestación
            th Prestación
            th Token
            th Fecha
            th Estado
            th Detalle
            th Valor
        tbody
          tr(v-for="validation in validations" :key="validation.id")
            td {{ validation.patient.firstName + " " + validation.patient.lastName }}
            td {{ validation.medicalService.code }}
            td.text-ellipsis {{ startCase(toLower(validation.medicalService.name)) }}
            td {{ validation.token }}
            td {{ validation.createdAt | formatDateAndTime }}
            td
              div.status-container(
              )
                micon(
                  :name="getStatusIcon(validation.status).name"
                  :color="getStatusIcon(validation.status).color"
                  width="18"
                  height="18"
                )
                span.status-text(:class="'status-' + validation.status")
                  | {{ getStatusText(validation.status) }}
            td {{ validation.failureReasons?.length > 0 ? getFailureReasonsText(validation.failureReasons) : "-" }}
            td {{ validation.price ? "$" + validation.price : "-" }}
    pagination(
      :isLoading="isLoading"
      :limit="pagination.limit"
      :total="pagination.total"
      @pagination="setPagination"
    )
  .box.box--with-subnav(v-else)
    box.box-without-results
      p.text-center No hay validaciones previas

</template>

<style lang="scss" scoped>
.status-container {
  display: flex;
  align-items: center;
  width: fit-content;
  gap: 5px;
  cursor: pointer;

  .status-text {
    font-weight: bold;
    font-size: 14px;

    &.status-valid {
      color: #67c23a;
    }

    &.status-invalid {
      color: #f56c6c;
    }

    &.status-pending {
      color: #e6a23c;
    }
  }
}

.text-ellipsis {
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.box-without-results {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  border-radius: 10px;
}
</style>
